import { render, staticRenderFns } from "./Ordenar.vue?vue&type=template&id=08a93214&"
import script from "./Ordenar.vue?vue&type=script&lang=js&"
export * from "./Ordenar.vue?vue&type=script&lang=js&"
import style0 from "./Ordenar.vue?vue&type=style&index=0&id=08a93214&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports